import React from 'react';

import {
    Modal,
    Button,
    Box,
    SpaceBetween,
    Alert,
    ColumnLayout,
    Link,
} from '@amzn/awsui-components-react-v3';
import { ValidateInstructorMessages } from '../../../../interfaces/validateActivityInstructorProfile';

interface EditDeliveryDetailsQualificationsModalProps {
    visible: boolean;
    onCancel: any;
    onConfirm: any;
    instructorConflict: any;
    formValues: any;
    missingQualifications: Array<string> | null;
}

const EditDeliveryDetailsQualificationsModal = ({
    onCancel,
    onConfirm,
    instructorConflict,
    visible,
    formValues,
    missingQualifications,
}: EditDeliveryDetailsQualificationsModalProps) => {
    return (
        <Modal
            onDismiss={() => onCancel}
            visible={visible}
            closeAriaLabel="Close modal"
            size="medium"
            data-testid={`ConfirmQualificationsModal`}
            footer={
                <Box float="right">
                    <SpaceBetween direction="horizontal" size="xs">
                        <Button
                            variant="link"
                            onClick={() => onCancel()}
                            data-testid={`ConfirmQualificationsCancel`}
                            key={`ConfirmQualificationsCancel`}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            data-testid={`ConfirmQualificationsConfirm`}
                            key={`ConfirmQualificationsConfirm`}
                            onClick={() => {
                                onConfirm();
                            }}
                        >
                            Yes, continue
                        </Button>
                    </SpaceBetween>
                </Box>
            }
            header={`Instructor conflict`}
        >
            <Alert
                onDismiss={() => {}}
                visible={true}
                dismissAriaLabel="Close alert"
                type="warning"
                key={`missing-qualifications-alert`}
            >
                {`${instructorConflict?.instructor.full_name}`} does not have
                the recommended qualifications for this activity. Continue
                assigning them?
            </Alert>
            <ColumnLayout key={`missing-qualifications-list`}>
                <div
                    data-awsui-column-layout-root="true"
                    className="reassign-adjacent-activity"
                >
                    <span className="reassign-adjacent-activity-title">
                        Missing recommended qualification:
                    </span>
                    {missingQualifications &&
                        missingQualifications.map(
                            (missingQualification, index) => {
                                return (
                                    <span
                                        key={`missing-qualification-${index}`}
                                    >
                                        {(missingQualification ===
                                            'wrong_language' ||
                                            missingQualification ===
                                                ValidateInstructorMessages.QUALIFICATION_LANGUAGE) && (
                                            <span>
                                                Delivery language:{' '}
                                                {formValues.delivery_language}
                                            </span>
                                        )}
                                        {(missingQualification ===
                                            'wrong_country' ||
                                            missingQualification ===
                                                ValidateInstructorMessages.QUALIFICATION_COUNTRY) && (
                                            <span>
                                                Delivery country:{' '}
                                                {formValues.delivery_country}
                                            </span>
                                        )}
                                        {(missingQualification ===
                                            'wrong_course' ||
                                            missingQualification ===
                                                ValidateInstructorMessages.QUALIFICATION_COURSE) && (
                                            <span>
                                                Approved course:{' '}
                                                {formValues.course_name}
                                            </span>
                                        )}
                                        {missingQualification ===
                                            ValidateInstructorMessages.WEBEX_HOST_LICENSE && (
                                            <span>
                                                Active WebEx host license: This
                                                instructor does not have an
                                                active WebEx host license on
                                                awsvirtual.webex.com.{' '}
                                                <Link
                                                    href="https://issues.amazon.com/issues/create?template=91e38ad6-6a3a-42c9-a847-b204f480a1fe"
                                                    external
                                                >
                                                    Request a WebEx license
                                                </Link>{' '}
                                                before assigning them.
                                            </span>
                                        )}
                                    </span>
                                );
                            },
                        )}
                </div>
            </ColumnLayout>
        </Modal>
    );
};

export default EditDeliveryDetailsQualificationsModal;
